import SelectCar from "../images/plan/icon1.png";
import Contact from "../images/plan/icon2.png";
import Drive from "../images/plan/icon3.png";

function PlanTrip() {
  return (
    <>
      <section className="plan-section">
        <div className="container">
          <div className="plan-container">
            <div className="plan-container__title">
              <h3>Reservez votre véhicule maintenant</h3>
              <h2>Simple & Rapide</h2>
            </div>

            <div className="plan-container__boxes">
              <div className="plan-container__boxes__box">
                <img src={SelectCar} alt="icon_img" />
                <h3>Selectionnez votre véhicule</h3>
                <p>
                  Nous proposons une large gamme de véhicules adaptés à tous vos besoins.
                  Vous trouverez toujours le véhicule idéal pour votre situation
                </p>
              </div>

              <div className="plan-container__boxes__box">
                <img src={Contact} alt="icon_img" />
                <h3>Contactez un opérateur</h3>
                <p>
                  Nos opérateurs compétents et chaleureux sont toujours prêts à vous
                  aider pour toute question ou préoccupation.
                </p>
              </div>

              <div className="plan-container__boxes__box">
                <img src={Drive} alt="icon_img" />
                <h3>Au volant !</h3>
                <p>
                  Que vous preniez la route ou partiez à l’aventure, nous avons
                  le véhicule qu’il vous faut grâce à notre large gamme de voitures.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PlanTrip;
